import { Link } from '@trashlab/sitesapp/src/components/shared/link';

export const WhyRedeBins = () => {
  const benefits = [
    {
      title: '>> Dumpster Rental Delivered In A Click',
      description:
        'You can check availability, reserve and pay, all online in a few quick minutes.',
    },
    {
      title: '>> It Fits Right In',
      description:
        "If you have space where you park a car, you've got space that fits a RED-E-BIN Dumpster.",
    },
    {
      title: '>> On Your Schedule, Not Ours',
      description:
        'We want you happy, period. So we make sure to deliver on-time, every time.',
    },
    {
      title: '>> Big Relief, Low Prices',
      description:
        'We make pricing simple, and are committed to being a service-first, affordable option.',
    },
    {
      title: '>> Here For You',
      description:
        "Got a complicated situation or just a quick question? Click on the yellow chat button to get the answers you need. You can also call or text us at (952) 931-2577, too!",
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-[#333333] mb-8 italic text-center">
            Why RED-E-BINS Dumpster Rental?
          </h2>

          <div className="grid md:grid-cols-2 gap-8 mb-8">
            <div className="space-y-6">
              {benefits.map((benefit, index) => (
                <div key={index}>
                  <h3 className="text-lg font-semibold text-[#E31837] mb-2">
                    {benefit.title}
                  </h3>
                  <p className="text-[#333333]">{benefit.description}</p>
                </div>
              ))}
            </div>

            <div className="flex flex-col items-center justify-center bg-gray-50 rounded-lg p-8">
              <h3 className="text-xl font-bold text-[#333333] mb-2">
                Need Assistance?
              </h3>
              <a
                href="tel:9529312577"
                className="text-3xl font-bold text-[#E31837] hover:underline mb-6"
              >
                952-931-2577
              </a>
              <img
                src="/redebins/images/binny-mascot.png"
                alt="Binny - RED-E-BINS Mascot"
                className="w-48 h-auto"
              />
            </div>
          </div>

          <div className="text-center">
            <Link
              href="/#dumpster-sizes"
              className="inline-block bg-[#E31837] text-white px-8 py-3 rounded-md font-semibold hover:bg-[#C1152E] transition-colors"
            >
              Click Here to Choose Your Dumpster Size
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

